import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { Grid, Divider, TextField, Button, FormGroup, FormControlLabel, Checkbox, Tab, Tabs, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core'
import { Search } from '@material-ui/icons'
import { API, DATE } from '@const'
import * as utils from '@utils'
import { BetRecordTable, TransferRecordTable, PaymentFlowRecordTable, EventAwardTable, Table } from '@tables'
import { DatetimeSelect, CompleteDecimal } from '@select'
// import { Select } from '@prototype'

// const COMPONENT_GROUP = 'member_search';

class MemberSearchPage extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'MemberSearchPage', options)
        }
    }

    state = {
        account: '',
        tableInput: {
            transferIn: true,
            transferOut: true,
            bet: true,
            profit: true,
            eventAward: true,
        },
        tab: 'bet',
        userData: {},
        searchType: 'all',
        searchValue: '',
        accountSearchType: 'originAccount',
        isSingleWallet: false
    }

    memberInfoTableColumns = [
        { field: 'pf_account' },
        { field: 'origin_account' },
        { field: 'name' },
        { field: 'pf_sub_pf_id', type: 'platform' },
        { field: 'created_at', type: 'datetime' },
        { field: 'money_lock', type: 'currency' },
        { field: 'money_free', type: 'currency' },
    ]

    options = {
        export: false,
    }

    componentDidMount() {
        // if (utils.checkValid(COMPONENT_GROUP + '.export')) {
        this.options.export = true
        // }
    }
    /* 單一錢包會員欄位處理 */
    handleSingleWalletChange = (isSingleWallet) => {
        if (isSingleWallet) {
            this.setState({ isSingleWallet: true })
            this.memberInfoTableColumns.push({
                field: 'is_single_wallet',
                type: 'center',
                render: (rowData) => (rowData['is_single_wallet'] ? 'V' : ''),
            })
            this.transferRecordTable.columns.splice(2, 0,
                {
                    field: 'round_id',
                }
            )
        } else {
            this.setState({ isSingleWallet: false })
            if (this.findColumnsField(this.memberInfoTableColumns, 'is_single_wallet')) {
                const columnIndex = this.memberInfoTableColumns.findIndex((col) => col.field === 'is_single_wallet')
                this.memberInfoTableColumns.splice(columnIndex, 1)
            }
            if (this.findColumnsField(this.transferRecordTable.columns, 'round_id')) {
                const columnIndex = this.transferRecordTable.columns.findIndex((col) => col.field === 'round_id')
                this.transferRecordTable.columns.splice(columnIndex, 1)
            }
        }
    }
    /** 尋找table欄位位置 */
    findColumnsField(columns, field) {
        return columns.find((col) => col.field === field)
    }

    queryUserData() {
        this.memberInfoTable.SetLoading(true)
        this.reset()

        const queryParams = {}
        if (this.state.accountSearchType === 'originAccount') {
            queryParams['origin_account'] = this.state.account
        } else  {
            queryParams['pf_account'] = this.state.account
        }

        utils.apiRequest(
            'get',
            API.PLAYER,
            queryParams,
            (data) => {
                const userData = {
                    ...data,
                    currency: utils.getPfCurrency(data['pf_id']),
                }
                /** 判斷是否為單一錢包會員 */
                this.handleSingleWalletChange(userData['is_single_wallet'])

                this.setState({
                    userData: userData
                })

                this.memberInfoTable.SetData(
                    [
                        {
                            ...userData,
                        },
                    ],
                    utils.getPfCurrency(data['pf_id'])
                )
            },
            (_err) => {
                this.memberInfoTable.SetLoading(false)
            }
        )
    }

    clearPageCache() {
        this.dateSelect.setState({
            startDate: utils.datetimeStartOfWithoutOffset(utils.currentDatetime(), 'day'),
            endDate: utils.datetimeEndOfWithoutOffset(utils.currentDatetime(), 'day')
        })
        this.memberInfoTable.SetData([])
        this.betRecordTable.SetData([])
        this.transferRecordTable.SetData([])
        this.paymentFlowRecordTable.SetData([])
        this.eventAwardTable.SetData([])
    }

    reset() {
        this.setState({
            tab: 'bet',
            searchType: 'all',
            searchValue: '',
            userData: {},
            tableInput: {
                transferIn: true,
                transferOut: true,
                bet: true,
                profit: true,
                eventAward: true,
            }
        })
        this.clearPageCache()
    }

    render() {
        return (
            <Grid container spacing={2}>
                <Grid item xs={2}>
                    <FormControl className={this.props.classes.formControlSelect}>
                    <InputLabel>{this.t('searchType')}</InputLabel>
                    <Select
                        value={this.state.accountSearchType}
                        onChange={(event) =>
                            this.setState({
                                accountSearchType: event.target.value,
                            })
                        }>
                        <MenuItem value="originAccount">{this.t('originAccount')}</MenuItem>
                        <MenuItem value="pfAccount">{this.t('pfAccount')}</MenuItem>
                    </Select>
                </FormControl>
                </Grid>
                <Grid item xs={2}>
                    <TextField
                        label={this.t('account')}
                        placeholder={this.t('enterAccountEntirely')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={this.state.account}
                        onChange={(event) =>
                            this.setState({
                                account: event.target.value,
                            })
                        }
                        className={this.props.classes.textField}
                    />
                </Grid>
                <Grid item className={this.props.classes.alignCenter}>
                    <Button variant="contained" color="primary" className={this.props.classes.button} onClick={() => this.queryUserData()}>
                        <Search className={this.props.classes.rightIcon} />
                        {this.t('search')}
                    </Button>
                </Grid>
                <Grid item className={this.props.classes.alignCenter}>
                    <CompleteDecimal />
                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid item xs={12}>
                    <Table
                        ownerName="MemberSearchPage"
                        columns={this.memberInfoTableColumns}
                        options={{ toolbar: false, paging: false }}
                        onRef={(ref) => (this.memberInfoTable = ref)}
                    />
                </Grid>
                <Grid item xs={12} className={Object.keys(this.state.userData).length === 0 ? this.props.classes.hide : ''}>
                    <Divider />
                </Grid>
                <Grid item xs={12} className={Object.keys(this.state.userData).length === 0 ? this.props.classes.hide : ''}>
                    <Tabs
                        value={this.state.tab}
                        onChange={(_evnet, value) => {
                            this.setState({ 
                                tab: value,
                                searchType: 'all',
                                searchValue: ''
                            })
                        }}
                        indicatorColor="primary"
                        textColor="primary">
                        <Tab value="bet" label={this.t('betHistory')} />
                        <Tab value="transfer" label={this.t('transferRecord')} />
                        <Tab value="eventAward" label={this.t('eventAward')} />
                        <Tab value="paymentFlow" label={this.t('paymentFlowRecord')} />
                    </Tabs>
                </Grid>
                <DatetimeSelect
                    options={{
                        hide: Object.keys(this.state.userData).length === 0,
                    }}
                    onRef={(ref) => (this.dateSelect = ref)}
                >
                </DatetimeSelect>
                <Grid item xs={2} className={Object.keys(this.state.userData).length === 0 || this.state.tab !== 'bet' ? this.props.classes.hide : ''}>
                    <FormControl className={this.props.classes.formControl}>
                        <InputLabel>{this.t('searchType')}</InputLabel>
                        <Select
                            value={this.state.searchType}
                            onChange={(event) => {
                                const value = event.target.value
                                this.setState({
                                    searchType: value,
                                    searchValue: ''
                                })
                            }
                                
                        }>
                            <MenuItem value="all">{this.t('treeDataAll')}</MenuItem>
                            <MenuItem value="game_overview">{this.t('gameOverview')}</MenuItem>
                            <MenuItem value="record_id">{this.t('betRecordId')}</MenuItem>
                            <MenuItem value="round_id">{this.t('roundId')}</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                
                <Grid item xs={2} className={Object.keys(this.state.userData).length === 0 || this.state.searchType === 'all' || this.state.searchType === 'game_overview' ? this.props.classes.hide : ''}>
                    <TextField
                        label={this.t('keyWordSearch')}
                        className={this.props.classes.searchSelect}
                        placeholder={this.t('pleaseEnter', { params: this.t(this.state.searchType === 'record_id' ? 'betRecordId' : 'roundId') })}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={this.state.searchValue}
                        onChange={(event) => {
                            const value = event.target.value
                            this.setState({
                                searchValue: value
                            })
                        }}
                    />
                </Grid>
                <Grid item xs={2} className={Object.keys(this.state.userData).length === 0 ? this.props.classes.hide : ''}>
                    <Button
                        variant="contained"
                        color="primary"
                        className={this.props.classes.button}
                        onClick={() => {
                            const queryParam = {
                                pf_account: this.state.userData['pf_account'],
                                start_date: utils.datetimeToUnix_startOf(this.dateSelect.state.startDate, 'minute'),
                                end_date: utils.datetimeToUnix_endOf(this.dateSelect.state.endDate, 'minute'),
                                lang: utils.getCurrentLang()
                            }

                            if (this.state.searchType === 'game_overview') {
                                queryParam.start_date = this.dateSelect.state.startDate
                                queryParam.end_date = this.dateSelect.state.endDate
                            }

                            switch (this.state.tab) {
                                case 'bet':
                                    this.betRecordTable.handleSearch({
                                        ...queryParam,
                                        timezone: DATE.CLIENT_UTC_OFFSET,
                                        keyword_field: this.state.searchType,
                                        keyword: this.state.searchValue,
                                        pf_sub_pf_id: this.state.userData.pf_sub_pf_id,
                                        pf_id: this.state.userData.pf_id
                                    })
                                    break
                                case 'transfer':
                                    this.transferRecordTable.queryData(queryParam)
                                    break
                                case 'paymentFlow':
                                    this.paymentFlowRecordTable.queryData({
                                        ...queryParam,
                                        transfer_in: this.state.tableInput.transferIn,
                                        transfer_out: this.state.tableInput.transferOut,
                                        bet: this.state.tableInput.bet,
                                        profit: this.state.tableInput.profit,
                                        event_award: this.state.tableInput.eventAward,
                                    })
                                    break
                                case 'eventAward':
                                    this.eventAwardTable.queryData(queryParam)
                                    break
                                default:
                            }
                        }}>
                        <Search className={this.props.classes.rightIcon} />
                        {this.t('search')}
                    </Button>
                </Grid>
                <Grid item xs={12} className={Object.keys(this.state.userData).length === 0 ? this.props.classes.hide : ''}>
                    <FormGroup row className={this.state.tab !== 'paymentFlow' ? this.props.classes.hide : ''}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    color="primary"
                                    checked={this.state.tableInput.transferIn}
                                    onChange={(event) =>
                                        this.setState({
                                            tableInput: {
                                                ...this.state.tableInput,
                                                transferIn: event.target.checked,
                                            },
                                        })
                                    }
                                    value="checkedA"
                                />
                            }
                            label={this.t('transferIn')}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    color="primary"
                                    checked={this.state.tableInput.transferOut}
                                    onChange={(event) =>
                                        this.setState({
                                            tableInput: {
                                                ...this.state.tableInput,
                                                transferOut: event.target.checked,
                                            },
                                        })
                                    }
                                    value="checkedA"
                                />
                            }
                            label={this.t('transferOut')}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    color="primary"
                                    checked={this.state.tableInput.bet}
                                    onChange={(event) =>
                                        this.setState({
                                            tableInput: {
                                                ...this.state.tableInput,
                                                bet: event.target.checked,
                                            },
                                        })
                                    }
                                    value="checkedA"
                                />
                            }
                            label={this.t('bet')}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    color="primary"
                                    checked={this.state.tableInput.profit}
                                    onChange={(event) =>
                                        this.setState({
                                            tableInput: {
                                                ...this.state.tableInput,
                                                profit: event.target.checked,
                                            },
                                        })
                                    }
                                    value="checkedA"
                                />
                            }
                            label={this.t('profit')}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    color="primary"
                                    checked={this.state.tableInput.eventAward}
                                    onChange={(event) =>
                                        this.setState({
                                            tableInput: {
                                                ...this.state.tableInput,
                                                eventAward: event.target.checked,
                                            },
                                        })
                                    }
                                    value="checkedA"
                                />
                            }
                            label={this.t('eventAward')}
                        />
                    </FormGroup>
                </Grid>
                <Grid
                    className={this.state.tab !== 'bet' || Object.keys(this.state.userData).length === 0 ? this.props.classes.hide : ''}
                    item
                    xs={12}>
                    <BetRecordTable onRef={(ref) => (this.betRecordTable = ref)} currency={this.state.userData.currency} />
                </Grid>
                <Grid
                    className={this.state.tab !== 'transfer' || Object.keys(this.state.userData).length === 0 ? this.props.classes.hide : ''}
                    item
                    xs={12}>
                    <TransferRecordTable onRef={(ref) => (this.transferRecordTable = ref)} currency={this.state.userData.currency} />
                </Grid>
                <Grid
                    className={this.state.tab !== 'eventAward' || Object.keys(this.state.userData).length === 0 ? this.props.classes.hide : ''}
                    item
                    xs={12}>
                    <EventAwardTable onRef={(ref) => (this.eventAwardTable = ref)} currency={this.state.userData.currency} />
                </Grid>
                <Grid
                    className={this.state.tab !== 'paymentFlow' || Object.keys(this.state.userData).length === 0 ? this.props.classes.hide : ''}
                    item
                    xs={12}>
                    <PaymentFlowRecordTable onRef={(ref) => (this.paymentFlowRecordTable = ref)} currency={this.state.userData.currency} />
                </Grid>
            </Grid>
        )
    }
}

const styles = (theme) => {
    return {
        formControl: {
            margin: theme.spacing(0),
            width: '100%',
            minWidth: 120,
        },
        formControlSelect: {
            margin: theme.spacing(1),
            width: '100%',
            minWidth: 120,
        },
        textField: {
            margin: theme.spacing(1),
            width: '100%',
            minWidth: 120,
        },
        button: {
            margin: theme.spacing(1),
        },
        rightIcon: {
            marginRight: theme.spacing(1),
        },
        root: {
            width: '100%',
            overflowX: 'auto',
        },
        table: {
            minWidth: 650,
        },
        hide: {
            display: 'none',
        },
        datePicker: {
            margin: theme.spacing(1),
            width: '15%',
            minWidth: 120,
        },
        alignCenter: {
            display: 'inline-flex',
            alignItems: 'center',
        },
        searchSelect: {
            width: '100%',
        },
    }
}

MemberSearchPage.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default hoc(styles)(MemberSearchPage)
